export default __webpack_public_path__ + "assets/icons/take_off.283a8579.svg";